import { GetMyTrackResponse, SortBy, Track } from "../../proto/api_pb";
import { TrackObj } from "./types";

export const convertToMyTrackObj = (
  trackResponse: GetMyTrackResponse
): TrackObj => {
  const t: Track | undefined = trackResponse.getTrack();
  const tUrl = trackResponse.getLatestTrackVersion()?.getTrackUrl();
  return {
    track: t,
    trackUrl: tUrl! ?? "",
    isPlaying: false,
    waveSurfer: undefined,
    versionCount: trackResponse.getTotalVersionCount(),
    latestVersion: trackResponse.getLatestTrackVersion(),
    notifications: trackResponse.getEventsList(),
  };
};

export const getSortByValue: (value: string) => 0 | 1 | 2 | 3 | 4 | 5 = (
  value: string
) => {
  switch (value) {
    case "Title":
      return SortBy.TITLE;
    case "Artist":
      return SortBy.ARTIST;
    case "Last Modified":
      return SortBy.LAST_MODIFIED;
    case "Date Created":
      return SortBy.DATE_CREATED;
    case "Notifications":
      return SortBy.NOTIFICATIONS;
    case "Custom Order":
      return SortBy.CUSTOM_SORTING;
    default:
      return SortBy.LAST_MODIFIED;
  }
};

export const getNextVersionNumber = (
  number: number,
  needSingle = false
): string[] => {
  const options = needSingle ? [] : ["Specify the version number"];

  if (Number.isInteger(number)) {
    options.push((number + 0.1).toFixed(1)); // Next decimal
    options.push((number + 1).toFixed(1)); // Next whole number
  } else if ((number * 10) % 10 === 9) {
    options.push(Math.ceil(number).toFixed(1)); // Next whole number
  } else {
    options.push((number + 0.1).toFixed(1)); // Next decimal
    options.push(Math.ceil(number).toFixed(1)); // Next whole number
  }

  return options;
};

export const getAudioDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = URL.createObjectURL(file);
    audio.onloadedmetadata = () => {
      resolve(audio.duration);
      URL.revokeObjectURL(audio.src);
    };
    audio.onerror = (error) => {
      resolve(0);
      URL.revokeObjectURL(audio.src);
    };
  });
};
